import { render, staticRenderFns } from "./PurchaseStatus.vue?vue&type=template&id=ff9532ee&"
import script from "./PurchaseStatus.vue?vue&type=script&lang=ts&"
export * from "./PurchaseStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports